export interface GenericErrorExtensions<ErrorKeys> {
  details?: {
    key: ErrorKeys;
  }[];
}
export interface ChangesetErrorExtensions<ErrorKeys = never> {
  details?: (
    | {
        key: ErrorKeys;
      }
    | ChangesetError
  )[];
}

export const ChangesetErrorKey = "changesetError" as const;

export interface ChangesetError {
  details: [
    {
      details: {
        message: string;
      };
      errorType: string;
      key: string;
    }
  ];
  key: typeof ChangesetErrorKey;
}

export enum LoginErrorKeys {
  accountLocked = "accountLocked",
  authError = "authError",
  emailVerificationRequired = "emailVerificationRequired",
  error = "error",
  passwordResetRequired = "passwordResetRequired",
}

export interface ErrorsInterface {
  [key: string]: string;
}

export enum SignupErrorKeys {
  authError = "authError",
  emailVerificationRequired = "emailVerificationRequired",
  unverifiedEmail = "unverifiedEmail",
}

export enum PersistTemporaryCartErrorKeys {
  cartIsNotTemporary = "cartIsNotTemporary",
}
